/* Capture Champagne : succès uniquement après stockage attribué ET acceptation Klaviyo.
   Puis 2e étape WhatsApp (28/10/2026) : le numéro part vers l'edge function `waitlist-whatsapp`,
   qui refuse un email absent de la liste, d'où son affichage seulement après les deux succès. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var forms = Array.from(root.querySelectorAll('[data-wlchamp-form]'));
    var busy = false;
    var savedEmails = new Set();
    var qs = new URLSearchParams(window.location.search);
    var utm = {};
    ['source', 'medium', 'campaign', 'content', 'term'].forEach(function (key) {
      utm['utm_' + key] = qs.get('utm_' + key) || null;
    });
    var landing = window.location.pathname + window.location.search;
    var storageKey = 'omads_waitlist_champagne_attribution';
    try {
      if (utm.utm_source) sessionStorage.setItem(storageKey, JSON.stringify({utm: utm, landing: landing}));
      else {
        var saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
        if (saved && saved.utm) { utm = saved.utm; landing = saved.landing || landing; }
      }
    } catch (_) { /* La capture reste possible si le navigateur bloque le stockage. */ }
    function channel() {
      if (utm.utm_source) return utm.utm_source.toLowerCase();
      var ref = document.referrer || '';
      if (/facebook|instagram|fb\./i.test(ref)) return 'meta';
      if (/tiktok/i.test(ref)) return 'tiktok';
      if (/google/i.test(ref)) return 'google';
      return 'site';
    }
    async function post(url, headers, payload) {
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 20000);
      try {
        return await fetch(url, {method: 'POST', headers: headers, body: JSON.stringify(payload), signal: controller.signal});
      } finally { clearTimeout(timer); }
    }
    async function capture(email) {
      if (savedEmails.has(email)) return;
      var publicKey = 'sb_publishable_QthosKqCipG4xedUnfPoaw_ooG-8YjW';
      var response = await post('https://eluljtthflzzsmrcoqlg.supabase.co/rest/v1/waitlist_subscriptions', {
        'Content-Type': 'application/json', apikey: publicKey, Authorization: 'Bearer ' + publicKey, Prefer: 'return=minimal'
      }, Object.assign({}, utm, {
        waitlist_name: 'shampoing-champagne', email: email,
        source: 'lp-liste-attente-shampoing-champagne', klaviyo_list_id: root.dataset.list,
        channel: channel(), page_url: landing, language: root.dataset.language.toUpperCase(),
        referrer: document.referrer || null, user_agent: navigator.userAgent || null
      }));
      if (!response.ok) {
        // Une contrainte UNIQUE peut confirmer une inscription déjà enregistrée.
        var error = await response.json().catch(function () { return {}; });
        if (response.status !== 409 || error.code !== '23505') throw new Error('waitlist_capture_failed');
      }
      savedEmails.add(email);
    }
    async function subscribe(email) {
      var response = await post('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.company), {
        accept: 'application/json', 'content-type': 'application/json', revision: '2024-10-15'
      }, {data: {
        type: 'subscription', attributes: {
          custom_source: 'LP Liste attente Shampoing Blond Beige',
          profile: {data: {type: 'profile', attributes: {email: email, properties: {
            waitlist_source: 'shampoing-champagne', waitlist_champagne: true,
            signup_date: new Date().toISOString(), wl_channel: channel(),
            wl_utm_source: utm.utm_source || 'organique', wl_utm_medium: utm.utm_medium || '',
            wl_utm_campaign: utm.utm_campaign || '', wl_utm_content: utm.utm_content || '',
            wl_language: root.dataset.language,
            // `lang` = la seule propriété que lisent les segments de langue (10/10/2026).
            lang: (root.dataset.language || 'fr').slice(0, 2).toUpperCase()
          }}}}
        }, relationships: {list: {data: {type: 'list', id: root.dataset.list}}}
      }});
      if (!response.ok) throw new Error('waitlist_subscription_failed');
    }
    /* Même normalisation que le popup et la carte « Bientôt » (dawn #460, #485). */
    function versE164(prefix, saisie) {
      var brut = String(saisie || '').trim();
      var chiffres = brut.replace(/\D/g, '');
      var e164;
      if (brut.charAt(0) === '+') e164 = '+' + chiffres;
      else if (chiffres.indexOf('00') === 0) e164 = '+' + chiffres.slice(2);
      else e164 = '+' + prefix + chiffres.replace(/^0+/, '');
      if (!/^\+[1-9]\d{7,14}$/.test(e164)) return null;
      var nat = {'352': [6, 11], '351': [9, 9], '353': [9, 9], '33': [9, 9], '32': [8, 9], '41': [9, 9],
                 '34': [9, 9], '39': [9, 11], '49': [10, 12], '43': [10, 13], '31': [9, 9], '48': [9, 9], '30': [10, 10]};
      for (var ind in nat) {
        if (e164.indexOf('+' + ind) === 0) {
          var reste = e164.length - 1 - ind.length;
          return (reste >= nat[ind][0] && reste <= nat[ind][1]) ? e164 : null;
        }
      }
      return e164;
    }
    async function envoyerWhatsapp(email, numero, essai) {
      var response = await post('https://eluljtthflzzsmrcoqlg.supabase.co/functions/v1/waitlist-whatsapp', {'Content-Type': 'application/json'},
        {waitlist: 'shampoing-champagne', email: email, whatsapp: numero,
         language: (root.dataset.language || 'fr').slice(0, 2).toUpperCase(), page_url: landing});
      var body = await response.json().catch(function () { return {}; });
      if (response.ok && body.ok) return;
      // L'insertion peut avoir quelques centaines de ms de retard : un seul nouvel essai.
      if (body.error === 'not_subscribed' && essai === 0) {
        await new Promise(function (r) { setTimeout(r, 2000); });
        return envoyerWhatsapp(email, numero, 1);
      }
      throw new Error(body.error || String(response.status));
    }
    function boites() {
      return forms.map(function (f) {
        var box = f.parentElement;
        return box && box.querySelector ? box.querySelector('[data-wlchamp-wa]') : null;
      });
    }
    /* Chaque formulaire a son bloc WhatsApp : tous s'ouvrent, le clavier va sur celui qui a servi. */
    function montrerWhatsapp(email, source) {
      var waBoxes = boites();
      waBoxes.forEach(function (wa, i) {
        if (!wa) return;
        forms[i].hidden = true;
        wa.hidden = false;
        if (wa.dataset.initialized) return;
        wa.dataset.initialized = 'true';
        var waForm = wa.querySelector('[data-wlchamp-wa-form]');
        var waInput = waForm.querySelector('[name="wa_number"]');
        var waBtn = waForm.querySelector('button[type="submit"]');
        var waErr = wa.querySelector('[data-wlchamp-wa-error]');
        waInput.addEventListener('input', function () { waErr.textContent = ''; });
        wa.querySelector('[data-wlchamp-wa-skip]').addEventListener('click', function () {
          waBoxes.forEach(function (w) { if (w) w.querySelector('[data-wlchamp-wa-step]').hidden = true; });
        });
        waForm.addEventListener('submit', async function (event) {
          event.preventDefault();
          if (waBtn.disabled) return;
          var numero = versE164(waForm.querySelector('[name="wa_prefix"]').value, waInput.value);
          if (!numero) { waErr.textContent = wa.dataset.invalid; return; }
          var texte = waBtn.textContent;
          waBtn.disabled = true; waBtn.textContent = wa.dataset.loading; waErr.textContent = '';
          try {
            await envoyerWhatsapp(email, numero, 0);
            waBoxes.forEach(function (w) {
              if (!w) return;
              w.querySelector('[data-wlchamp-wa-step]').hidden = true;
              w.querySelector('[data-wlchamp-wa-done]').hidden = false;
            });
          } catch (error) {
            waErr.textContent = (error && error.message === 'bad_whatsapp') ? wa.dataset.invalid : wa.dataset.error;
            waBtn.disabled = false; waBtn.textContent = texte;
            console.error('[waitlist-champagne] Échec de l’étape WhatsApp', error && error.message);
          }
        });
      });
      var cible = waBoxes[forms.indexOf(source)];
      if (cible) {
        try { cible.querySelector('[name="wa_number"]').focus({preventScroll: true}); } catch (_) { /* focus refusé */ }
      }
    }
    forms.forEach(function (form) {
      var input = form.querySelector('input[type="email"]');
      var button = form.querySelector('button');
      var feedback = form.querySelector('[data-wlchamp-feedback]');
      var original = button.textContent;
      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (busy) return;
        input.value = input.value.trim().toLowerCase();
        if (!form.reportValidity()) return;
        if (!root.dataset.list || !root.dataset.company) { feedback.textContent = form.dataset.error; return; }
        var email = input.value;
        busy = true;
        forms.forEach(function (f) { f.querySelector('button').disabled = true; f.querySelector('input').disabled = true; });
        button.textContent = form.dataset.loading;
        feedback.textContent = '';
        try {
          await capture(email);
          await subscribe(email);
          forms.forEach(function (f) {
            f.querySelector('[data-wlchamp-feedback]').textContent = f.dataset.success;
            f.querySelector('button').textContent = f.dataset.done;
            f.querySelector('input').disabled = true;
          });
          montrerWhatsapp(email, form);
        } catch (error) {
          feedback.textContent = form.dataset.error;
          button.textContent = original;
          forms.forEach(function (f) { f.querySelector('button').disabled = false; f.querySelector('input').disabled = false; });
          busy = false;
          // Pas d'email dans le journal de diagnostic du navigateur.
          console.error('[waitlist-champagne] Échec de capture ou de consentement', error.name);
        }
      });
    });
  }
  function all() { document.querySelectorAll('[data-wlchamp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
})();
